document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.brands-viewport').forEach(function (viewport) {
    var track = viewport.querySelector('[data-brands-track]');
    if (!track) return;

    var originalCards = Array.from(track.children);
    originalCards.forEach(function (card) {
      track.appendChild(card.cloneNode(true));
    });

    var position = 0;
    var speed = 0.5;
    var isPaused = false;
    var loopWidth = 0;

    function calcLoopWidth() {
      loopWidth = 0;
      originalCards.forEach(function (card) {
        loopWidth += card.offsetWidth + 18;
      });
    }
    calcLoopWidth();
    window.addEventListener('resize', calcLoopWidth);

    function animate() {
      if (!isPaused) {
        position += speed;
        if (position >= loopWidth) position = 0;
        track.style.transform = 'translateX(' + (-position) + 'px)';
      }
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);

    viewport.addEventListener('mouseenter', function () { isPaused = true; });
    viewport.addEventListener('mouseleave', function () { isPaused = false; });
  });
});